import BookingHistoryContainer from './BookingHistoryContainer'

const BookingHistory = () => {
  return (
    <div className='page-body'>
      <BookingHistoryContainer />
    </div>
  )
}

export default BookingHistory